import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';

interface ModelOption {
  value: string;
  label: string;
}

interface ModelSelectorProps {
  value: string;
  onChange: (value: 'gpt-4o' | 'gpt-4' | 'gpt-4o-mini') => void;
  models: readonly ModelOption[];
  'data-testid'?: string;
}

const ModelSelector: React.FC<ModelSelectorProps> = ({
  value,
  onChange,
  models,
  'data-testid': testId,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value as 'gpt-4o' | 'gpt-4' | 'gpt-4o-mini');
  };

  return (
    <FormControl size="small" sx={{ minWidth: 150 }}>
      <InputLabel id="model-select-label">Model</InputLabel>
      <Select
        labelId="model-select-label"
        value={value}
        label="Model"
        onChange={handleChange}
        data-testid={testId}
        aria-label="Select AI model"
      >
        {models.map((model) => (
          <MenuItem key={model.value} value={model.value}>
            {model.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ModelSelector;
